import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { blogData } from "../../blogs";
import { getTopic } from "../../utils/config";

const TopicsContainer = () => {
  const [topics, setTopics] = useState([]);

  useEffect(() => {
    const topics = blogData.filter((b) => b.pillarTopic).map((b) => b.pillarTopic);
    setTopics([...Array.from(new Set(topics))]);
  }, [blogData]);

  return (
    <div className="">
      <h5 className="font-weight-bold">Related Topics</h5>
      {topics.map((t) => (
        <Link type="button" class="btn btn-outline-danger mr-3 my-2" to={`/blogs/${getTopic(t)}`}>
          {t}
        </Link>
      ))}
    </div>
  );
};

export default TopicsContainer;
